// extracted by mini-css-extract-plugin
export default {"capa":"Modal_capa__3AQ+2","caja":"Modal_caja__Hxhd9"};